export enum ModesEnum {
    Days = 1,
    Transactions = 2
}
export enum OrderStatesEnum {
    VNPay = 131072
}
// export let OrderStatesView = {
//     Gateway: 65536,
//     Methods: {
//         'VNPay QR': 131072,
//         'Đổi điểm': 262144,
//         'VinID': 524288,
//         'ZaloPay': 1048576,
//         'ViettelPay': 2097152,
//         'Momo': 4194304,
//         'Moca': 8388608
//     }
// }
export interface ReconcileDto {
    ID: number,
    Gateway: OrderStatesEnum,
    Since: string,
    Until: string,
    Mode: ModesEnum,
}

